module.exports = __webpack_public_path__ + "img/33.99c3a95c.jpg";